import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledBadgesWrapper, StyledBadge, StyledBadgeLabel, } from './Tile.style';
import { Icon } from '../Icon';
const badgePositions = [
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
];
export function TileBadge({ badges, visible }) {
    return (_jsx(_Fragment, { children: badgePositions
            .map((position) => [
            position,
            badges.filter((badge) => (!(badge === null || badge === void 0 ? void 0 : badge.position) && position === 'top-left') ||
                (badge === null || badge === void 0 ? void 0 : badge.position) === position),
        ])
            .map(([position, badgeList], index) => Array.isArray(badgeList) && badgeList.length > 0 ? (_jsx(StyledBadgesWrapper, { visible: visible, position: position, children: badgeList === null || badgeList === void 0 ? void 0 : badgeList.map((badge) => (_jsxs(StyledBadge, { backgroundColor: badge.backgroundColor, children: [_jsx(Icon, { name: badge.name, size: badge.size }), badge.label && (_jsx(StyledBadgeLabel, { children: badge.label }))] }, `tile-badge-item-${badge.name}-${index}`))) }, `tile-badge-wrapper-${position}-${index}`)) : null) }));
}
//# sourceMappingURL=TileBadge.js.map